import { render, staticRenderFns } from "./listTingbox.vue?vue&type=template&id=06de48c8&scoped=true"
import script from "./listTingbox.vue?vue&type=script&lang=js"
export * from "./listTingbox.vue?vue&type=script&lang=js"
import style0 from "./listTingbox.vue?vue&type=style&index=0&id=06de48c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de48c8",
  null
  
)

export default component.exports